module.exports = "../study/imgs/maps/Tokyo/S8/Hazard/Slopefailure/Tokyo_Slopefailure_MRI_RCP45_Mid.png";